export const APPLICATION_CONSTANTS = {
  APPLICATION_NAME: 'frontend-translations',
  APPLICATION_ROOT_URL: '/translations',
  APP_ROOT_CONTAINER_ID: 'root',

  DEFAULT_LANGUAGE_CODE: 'EN',
  CLIENT_ID: 'SEP-Translations-Frontend',
};
